<template>
  <button
    class="lt-theme-toggle"
    @click="onToggle"
    :aria-pressed="isDark"
    aria-label="Toggle theme"
    type="button"
  >
    <font-awesome-icon :icon="isDark ? 'fa-solid fa-sun' : 'fa-solid fa-moon'" class="lt-theme-toggle__icon" />
    <span class="lt-theme-toggle__label">{{ isDark ? 'Light' : 'Dark' }}</span>
  </button>
</template>

<script>
import { toggleTheme, initTheme } from '@/utils/theme';

export default {
  name: 'ThemeToggle',
  data: () => ({ isDark: false }),
  mounted() {
    // Ensure initial theme is applied (no-op if already done in App)
    const current = document.documentElement?.getAttribute('data-theme')
      || initTheme();
    this.isDark = current === 'dark';
  },
  methods: {
    onToggle() {
      const next = toggleTheme();
      this.isDark = (next === 'dark');
    }
  }
};
</script>

<style scoped>
.lt-theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid var(--grid-lines);
  background: var(--card-bg);
  color: var(--text-primary);
  border-radius: var(--radius-button);
  transition: var(--transition);
}
.lt-theme-toggle:hover { box-shadow: 0 0 0 3px rgba(51,156,255,0.28); }
.lt-theme-toggle__icon { font-size: 14px; }
.lt-theme-toggle__label { font-size: 12px; font-weight: var(--fw-button); }
</style>
